import React from 'react';

import '../styles/Pagination.css';


type PaginationProps = {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}


const getPageList = (currentPage: number, totalPages: number): Array<number | '...'> => {
    const pages: Array<number | '...'> = [];
    const addPage = (p: number) => {
        if (!pages.includes(p)) pages.push(p);
    };

    addPage(1);
    for (let p = currentPage - 1; p <= currentPage + 1; p++) {
        if (p > 1 && p < totalPages) addPage(p);
    }
    if (totalPages > 1) addPage(totalPages);

    const withEllipsis: Array<number | '...'> = [];
    let prev: number | null = null;
    pages.sort((a, b) => (a as number) - (b as number)).forEach((p) => {
        if (prev !== null && (p as number) - prev > 1) {
            withEllipsis.push('...');
        }
        withEllipsis.push(p);
        prev = p as number;
    });

    return withEllipsis;
}


const Pagination = (props: PaginationProps) => {
    const { currentPage, totalPages, onPageChange } = props;

    if (totalPages <= 1) return null;

    const pageList = getPageList(currentPage, totalPages);

    return (
        <nav className='pagination'>
            <button
                type='button'
                className='pagination__btn pagination__btn-nav'
                disabled={currentPage <= 1}
                onClick={() => onPageChange(currentPage - 1)}
            >Назад</button>

            {
                pageList.map((p, i) =>
                    p === '...' ?
                        <span key={`ellipsis${i}`} className='pagination__ellipsis'>…</span>
                        :
                        <button
                            key={`page${p}`}
                            type='button'
                            className={`pagination__btn pagination__btn-page${p === currentPage ? ' pagination__btn-page-active' : ''}`}
                            disabled={p === currentPage}
                            onClick={() => onPageChange(p as number)}
                        >{p}</button>
                )
            }

            <button
                type='button'
                className='pagination__btn pagination__btn-nav'
                disabled={currentPage >= totalPages}
                onClick={() => onPageChange(currentPage + 1)}
            >Вперед</button>
        </nav>
    );
};


export default Pagination;
